import { Component, OnInit, ViewChild } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';

@Component({
    selector: 'app-appeals',
    templateUrl: './appeals.component.html',
    styleUrls: ['./appeals.component.scss'],
    standalone: false
})
export class AppealsComponent implements OnInit {
  @ViewChild(DatalistviewComponent) datalistview!: DatalistviewComponent;

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Citation', 'CitationId'),
    new Datalistviewcolumn('Infringement', 'InfringementTypeName'),
    new Datalistviewcolumn('Status', 'CurrentStateKey'),
    new Datalistviewcolumn('Submitted', 'SubmissionDateLocalFriendlyString'),
    new Datalistviewcolumn('Decision', 'DecisionDateLocalFriendlyString'),
    new Datalistviewcolumn('Email', 'EmailAddress')
  ];

  constructor() { }

  async ngOnInit(): Promise<void> {
    // Set default sort to ID descending (newest first)
    setTimeout(() => {
      if (this.datalistview && this.datalistview.Filter) {
        this.datalistview.Filter.OrderByProperty = "Id";
        this.datalistview.Filter.Ascending = false;
      }
    });
  }

  public getStatuses() {
    return [
      "Open",
      "Resolved",
      "Submitted",
      "UnderReview",
      "Reopened",
      "Upheld",
      "Denied"
    ];
  }
}


